import { ColumnInstance } from "react-table";
import { TextField } from "../../form/fields";
import { FilterExpressionChildInput, FilterOperatorEnum, GraphQLTableColumn, Maybe } from "../../GraphQL";
import { useDebouncedFilter } from "./utils";

export function TextColumnTemplate<T extends object = {}>(params?: GraphQLTableColumn<T>): GraphQLTableColumn<T> {
  return {
    Header: "",
    filterOperator: FilterOperatorEnum.StartsWith,
    filterExpressionBuilder: (p): Maybe<FilterExpressionChildInput> => {
      let value = p.value;

      if (p.operator === FilterOperatorEnum.StartsWith ||
        p.operator === FilterOperatorEnum.EndsWith ||
        p.operator === FilterOperatorEnum.Contains) {
        value = p.value?.trim();
      }

      return value ? ({
        entry: {
          path: p.path,
          operator: p.operator,
          value,
        },
      }) : null;
    },
    Filter: ({ column: { filterValue, setFilter } }: { column: ColumnInstance }) => {
      const [ value, onChange ] = useDebouncedFilter(filterValue, setFilter);
      return (
        <TextField
          placeholder="Find..."
          value={value}
          onChange={onChange}
          disabled={params?.filterInputDisabled}
        />
      );
    },
    ...params,
  };
}

export default TextColumnTemplate;
